<!--
 * @Author: pengyong
 * @Date: 2020-11-13 21:15:15
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-29 14:10:15
 * @Description: 登录、注册、选择身份公共父组件
 * @FilePath: /exhibit/src/components/CommonWrapper/index.vue
-->
<template>
    <div class="common-wrapper">
        <div class="modal" :style="{ width, height }">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        modalWidth: {
            type: [Number, String],
            default: 1000
        },
        modalHeight: {
            type: [Number, String],
            default: 600
        }
    },
    computed: {
        width() {
            return this.formatValue(this.modalWidth);
        },
        height() {
            return this.formatValue(this.modalHeight);
        }
    },
    methods: {
        formatValue(val) {
            return typeof val === "number" ? val + "px" : val;
        }
    }
};
</script>

<style lang="scss" scoped>
.common-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: url("~@/assets/bg-login.png") no-repeat center;
    overflow: hidden;
    width: 100%;
    height: 100%;
    .modal {
        background: #ffffff;
        box-shadow: 0px 6px 12px 6px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonWrapper/index.vue